import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CloudTabComponent from './../Components/CloudTabComponent.jsx';

// Selectors
import {
  getCloudAcquisitions,
  getCloudPlatforms,
  getCloudBuildInfo,
  getCloudBuildNumber,
  getCloudBuildTimestamp
} from '../reducers';

// API Actions
import {
  fetchCloudAcquisitions,
  fetchBuildInfo
} from './../actions';

// This is the main component for the cloud page.  Container is effectively
// glue between the state/model and the view/html
export class CloudContainer extends Component {
  static propTypes = {
    fetchCloudAcquisitions: PropTypes.func.isRequired,
    acquisitions : PropTypes.array.isRequired,
    platforms: PropTypes.array.isRequired,
    fetchBuildInfo: PropTypes.func.isRequired,
    buildInfo: PropTypes.array.isRequired,
    buildNumber: PropTypes.number.isRequired,
    timestamp: PropTypes.string.isRequired
  };

  componentDidMount() {
    //Get the most recent acquisitions
    this.props.fetchBuildInfo();
    this.props.fetchCloudAcquisitions();
  }

  render() {
    return (
      <CloudTabComponent acquisitions={this.props.acquisitions}
        buildNumber={this.props.buildNumber}
        timestamp={this.props.timestamp}
      />
    );
  }
}

// Convert the state object to props for the component
export const mapStateToProps = (state) => {
  return {
    buildInfo: getCloudBuildInfo(state),
    acquisitions: getCloudAcquisitions(state),
    platforms: getCloudPlatforms(state),
    buildNumber: getCloudBuildNumber(state),
    timestamp: getCloudBuildTimestamp(state)
  };
};

export default connect(
  mapStateToProps,
  {
    fetchCloudAcquisitions,
    fetchBuildInfo
  }
)(CloudContainer);


// WEBPACK FOOTER //
// src/Containers/CloudContainer.jsx